import '@xyflow/react/dist/style.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';
import { worker } from 'src/__mocks__/browser';
import { GlobalProvider } from 'src/context/global/global-provider';

import App from './App';
import { WEB_UI_API_BASE_URL } from './config';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

async function bootstrap() {
  if (WEB_UI_API_BASE_URL === '' || WEB_UI_API_BASE_URL === undefined) {
    // eslint-disable-next-line no-console
    console.log('Starting mocks');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  root.render(
    <React.StrictMode>
      <GlobalProvider>
        <App />
        <ToastContainer
          position="top-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
      </GlobalProvider>
    </React.StrictMode>,
  );
}

bootstrap().catch(() => {});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
